__turbopack_context__.v({
  "appSidemenu": "Sidebar-module__XRNO5a__appSidemenu",
  "appSidemenuCollapsed": "Sidebar-module__XRNO5a__appSidemenuCollapsed",
  "appSidemenuForceExpanded": "Sidebar-module__XRNO5a__appSidemenuForceExpanded",
  "collapseToggle": "Sidebar-module__XRNO5a__collapseToggle",
  "collapseToggleWrapper": "Sidebar-module__XRNO5a__collapseToggleWrapper",
  "navgroup": "Sidebar-module__XRNO5a__navgroup",
  "navgroupheading": "Sidebar-module__XRNO5a__navgroupheading",
  "navgrouptoggle": "Sidebar-module__XRNO5a__navgrouptoggle",
  "navheading": "Sidebar-module__XRNO5a__navheading",
  "navitem": "Sidebar-module__XRNO5a__navitem",
  "navitemActive": "Sidebar-module__XRNO5a__navitemActive",
  "navlabel": "Sidebar-module__XRNO5a__navlabel",
  "navsubitem": "Sidebar-module__XRNO5a__navsubitem",
  "scrollAreaWrapper": "Sidebar-module__XRNO5a__scrollAreaWrapper",
  "sidemenuInner": "Sidebar-module__XRNO5a__sidemenuInner",
  "sidemenunav": "Sidebar-module__XRNO5a__sidemenunav",
  "sidemenunavBottom": "Sidebar-module__XRNO5a__sidemenunavBottom",
  "sidemenunavTop": "Sidebar-module__XRNO5a__sidemenunavTop",
});
